import React from 'react';
import { ABOUT, SITE } from '../../mock';

export default function About() {
  return (
    <section id="about" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 md:gap-16 items-center">
        <div className="order-2 md:order-1">
          <h2 className="font-serif text-white text-[34px] md:text-[52px] leading-[1.08] tracking-tight whitespace-pre-line">
            {ABOUT.heading}
          </h2>
          <p className="mt-7 text-neutral-400 text-[15px] md:text-[17px] leading-[1.75]">
            {ABOUT.body}
          </p>
          <div className="mt-8 flex items-center gap-6">
            <div className="h-px w-16 bg-amber-300/60" />
            <span className="text-[11px] tracking-[0.25em] uppercase text-amber-300/80">
              Nishit Thakkar &middot; Manifestation Coach
            </span>
          </div>
        </div>

        <div className="order-1 md:order-2">
          <div className="relative mx-auto w-full max-w-md">
            <div className="absolute -inset-4 rounded-3xl bg-gradient-to-br from-amber-300/20 via-transparent to-transparent blur-2xl" />
            <div className="relative rounded-3xl overflow-hidden border border-white/10 bg-navy-900">
              <img
                src={SITE.authorImage}
                alt="Nishit Thakkar"
                className="w-full h-[520px] object-cover"
                loading="lazy"
              />
              <div className="absolute inset-x-0 bottom-0 p-5 bg-gradient-to-t from-navy-950 via-navy-950/60 to-transparent">
                <p className="text-amber-300 text-xs tracking-[0.2em] uppercase">15+ Years of Practice</p>
                <p className="text-white font-serif text-2xl mt-1">Nishit Thakkar</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
